export default __webpack_public_path__ + "static/media/banner_tutoriales.c47b6b9c.png";